var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAmex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 18.403,
    viewBox: "0 0 30 18.403",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_860",
    "data-name": "Group 860",
    transform: "translate(-523 -91)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_859",
    "data-name": "Group 859",
    transform: "translate(7.863 -41.359)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_858",
    "data-name": "Group 858",
    transform: "translate(516 133)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_636",
    "data-name": "Group 636",
    transform: "translate(4.145 6.364)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M-3.1-1.247c-.223.625-.438,1.229-.657,1.841h1.315L-3.1-1.247M5.714-2.3V2.959H4.664V-.792H4.646l-.212.558q-.591,1.55-1.179,3.105a.121.121,0,0,1-.135.1c-.287-.006-.574-.005-.862,0a.113.113,0,0,1-.127-.092Q1.457,1.026.776-.821a.321.321,0,0,0-.055-.1v3.88c-.04,0-.071.006-.1.006H-1.427a.1.1,0,0,1-.079-.017A.1.1,0,0,1-1.55,2.88c-.108-.34-.225-.677-.334-1.016A.1.1,0,0,0-1.925,1.8.1.1,0,0,0-2,1.781H-4.068a.1.1,0,0,0-.117.09c-.11.336-.225.67-.334,1.007-.021.064-.047.091-.119.089H-5.732c.012-.039.021-.072.033-.1Q-4.742.325-3.8-2.207A.121.121,0,0,1-3.659-2.3c.412,0,.824.005,1.235,0a.137.137,0,0,1,.155.108Q-1.4.179-.523,2.55a.294.294,0,0,0,.051.1V-2.3H1.28a.116.116,0,0,1,.13.09Q2.027-.535,2.65,1.14c.01.028.023.055.044.1.061-.161.115-.3.167-.445q.556-1.5,1.109-3a.126.126,0,0,1,.143-.1H5.606Z",
    transform: "translate(5.724 2.302)",
    fill: "#ec812d",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_637",
    "data-name": "Group 637",
    transform: "translate(17.041 6.365)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M-5.592-3.113c-.344-.474-.681-.938-1.022-1.4a.156.156,0,0,0-.112-.047h-2.46a.463.463,0,0,0-.083.005v.919h2.353v1.052H-9.269V-1.54h2.427a.162.162,0,0,0,.109-.06c.16-.207.314-.418.472-.626l.669-.891M-10.326-.481V-5.746h4.242a.161.161,0,0,1,.153.085q.465.7.933,1.4c.019.028.04.056.064.09l.065-.076c.4-.475.794-.949,1.187-1.427a.187.187,0,0,1,.163-.075h1.348L-4.145-3.113l1.97,2.626c-.046,0-.076,0-.1,0h-1.12a.158.158,0,0,1-.143-.07q-.587-.769-1.177-1.533c-.025-.033-.051-.065-.084-.107l-.083.106L-6.053-.561a.177.177,0,0,1-.158.08h-4.115Z",
    transform: "translate(10.326 5.748)",
    fill: "#ec812d",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_308",
    "data-name": "Group 308",
    transform: "translate(523 91)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M-297.875-19.167q-6.875,0-13.751,0c-.221,0-.3.046-.3.287q.01,7.953,0,15.907c0,.239.077.288.3.288q13.751-.008,27.5,0c.308,0,.309,0,.309-.318q0-7.918,0-15.835c0-.319,0-.319-.331-.319h-13.727m15.006,17.438c-.1,0-.191-.013-.286-.013h-29.428c-.1,0-.191.008-.286.013v-18.4c.1,0,.191.013.286.013h29.428c.1,0,.191-.008.286-.013Z",
    transform: "translate(312.869 20.132)",
    fill: "#ec812d",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M0-384H30v18.4H0Z",
    transform: "translate(523 475)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAmex);
export default __webpack_public_path__ + "static/media/icon-amex.069e991420818f40b9678e1d6cbd5728.svg";
export { ForwardRef as ReactComponent };